export const SET_PAYMENT_DATA = 'rpb2b-react/payments/SET_PAYMENT_DATA';
export type SET_PAYMENT_DATA = typeof SET_PAYMENT_DATA;

export const SET_PAYMENT_PAGE_NUMBER =
  'rpb2b-react/payments/SET_PAYMENT_PAGE_NUMBER';
export type SET_PAYMENT_PAGE_NUMBER = typeof SET_PAYMENT_PAGE_NUMBER;

export const SET_PAYMENT_PAGE_SIZE =
  'rpb2b-react/payments/SET_PAYMENT_PAGE_SIZE';
export type SET_PAYMENT_PAGE_SIZE = typeof SET_PAYMENT_PAGE_SIZE;

export const SET_PAYMENT_TOTAL_ELEMENTS =
  'rpb2b-react/payments/SET_PAYMENT_TOTAL_ELEMENTS';
export type SET_PAYMENT_TOTAL_ELEMENTS = typeof SET_PAYMENT_TOTAL_ELEMENTS;

export const SET_PAYMENT_TOTAL_PAGES =
  'rpb2b-react/payments/SET_PAYMENT_TOTAL_PAGES';
export type SET_PAYMENT_TOTAL_PAGES = typeof SET_PAYMENT_TOTAL_PAGES;

export const SET_PAYMENT_IS_PENDING =
  'rpb2b-react/payments/SET_PAYMENT_IS_PENDING';
export type SET_PAYMENT_IS_PENDING = typeof SET_PAYMENT_IS_PENDING;

export const SET_PAYMENT_ERROR = 'rpb2b-react/payments/SET_PAYMENT_ERROR';
export type SET_PAYMENT_ERROR = typeof SET_PAYMENT_ERROR;

export default {
  SET_PAYMENT_DATA,
  SET_PAYMENT_PAGE_NUMBER,
  SET_PAYMENT_PAGE_SIZE,
  SET_PAYMENT_TOTAL_ELEMENTS,
  SET_PAYMENT_TOTAL_PAGES,
  SET_PAYMENT_IS_PENDING,
  SET_PAYMENT_ERROR
};
